

















































import Vue from 'vue'
import Message from '@/models/Message/Message'
import msgrIcon from './msgrIcon.vue'
import voteIcon from './voteIcon.vue'
import voteResult from './voteResult.vue'
import {wrapLinksInTag} from '@/lib/links'
import {
  MESSAGE_TYPE_LSNUSER,
  MESSAGE_TYPE_STAFFUSER,
  MESSAGE_TYPE_NOTIFY,
  MESSAGE_TYPE_MAILING,
  MESSAGE_TYPE_POLL,
  MESSAGE_MSGR_STATUS_OK,
  MESSAGE_MSGR_STATUS_ERR
} from '@/constants'
export default Vue.extend({
  components: {msgrIcon, voteResult, voteIcon},
  props: {
    msg: Object as () => Message,
  },
  data () {
    return {
      MESSAGE_MSGR_STATUS_OK,
      MESSAGE_MSGR_STATUS_ERR,
      MESSAGE_TYPE_MAILING,
      MESSAGE_TYPE_POLL,
      MESSAGE_TYPE_STAFFUSER
    }
  },
  methods: {
    wrapText () {
      return wrapLinksInTag(this.msg.getText())
    },
    isActiveVote (val: string) {
      const ans = this.msg.getVote() && this.msg.getVote()!.ans
      return ans === val;
    }
  },
  computed: {
    isFromUser (): boolean {
      return !(this.msg.getType() === MESSAGE_TYPE_LSNUSER)
    }
  }
})
